import useAuth from "../hooks/useAuth";

const AuthRoute = ({children}) => {
    const username = useAuth();
    return username && children;
}

export default AuthRoute;
